import { render, staticRenderFns } from "./real-estate-development.vue?vue&type=template&id=f6ef30fe&"
import script from "./real-estate-development.vue?vue&type=script&lang=js&"
export * from "./real-estate-development.vue?vue&type=script&lang=js&"
import style0 from "./real-estate-development.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports